import { useAppUserAccess } from 'global/cnr/contexts/useHelpers/useAppUserAccess';
import { useColors } from 'global/cnr/contexts/useHelpers/useColors';
import { createInitials } from 'global/common/dataAdjust';
import { uniqueKey } from 'global/common/keys';
import ItemMenuSquares, { _imsTypes } from 'global/wrappers/ItemMenuSquares';
import Wrapper from 'global/wrappers/Wrapper';
import _ from 'lodash';
import { useContext, useEffect, useMemo, useState } from 'react';
import { Icon, Label } from 'semantic-ui-react';
import { GolfParentContext } from '../cnr/contexts/GolfParentContext';
import { useGolfers } from '../useHelpers/useGolfers';
import GolferAdd from './GolferAdd';
import GolferChange from './GolferChange';
import GolferHandicap from './GolferHandicap';
import GolferHandicapLabelGroup from './GolferHandicapLabelGroup';
import { handicapModes, handicapRowModes } from './GolferRow';
import { golferEventHeaderModes, golferEventHeaderModes_admin, golferTeamModes, golferTournamentHeaderModes, golferTournamentHeaderModes_admin } from './Golfers';

export const golferRecordSorts = {
  name: 'name',
  points: 'points',
  holes: 'holes',
}

export const GolferSquares = ({ golfers, teams, allowMods }) => {

  const { getContrastColor, getSplitColorStyles } = useColors()
  const { get_golferHandicaps, update_golfHandicapRecommendations, get_golferRecords } = useGolfers()

  const appUserAccess = useAppUserAccess()
  const { isSuperAdminDeveloper } = appUserAccess ?? {}

  const golfParentContext = useContext(GolfParentContext)
  const { golfParent_contexts } = golfParentContext ?? {}
  const { states } = golfParent_contexts ?? {}
  const { golfEvent_state, golfTournament_state } = states ?? {}
  const { golfers: golfers_event } = golfEvent_state ?? {}
  const {
    golfTeam1,
    golfTeam2,
    golfStyles,
    tournamentGolfCourses,
    golfers: golfers_tournament,
    matches_rounds,
    rounds,
  } = golfTournament_state ?? {}

  const _rounds = rounds ? _.sortBy(rounds, 'roundNumber') : []

  const isTournament = golfers_tournament ? true : false

  const { roundColors, golfTeam1Style, golfTeam2Style } = golfStyles ?? {}

  const [currentGolferHcp, setCurrentGolferHcp] = useState()
  const [currentGolferEdit, setCurrentGolferEdit] = useState()
  const [currentChangeGolfer, setCurrentChangeGolfer] = useState()
  const [currentTeamMode, setCurrentTeamMode] = useState(golferTeamModes.all)
  const [currentHeaderMode, setCurrentHeaderMode] = useState(golferTournamentHeaderModes.handicaps)
  const [currentSortMode, setSortMode] = useState(golferRecordSorts.name)
  const [currentGolfers, setCurrentGolfers] = useState()

  const { _golferTeamModes } = useMemo(() => {
    const mts = _.map(golferTeamModes, mt => {
      switch (mt) {
        case golferTeamModes.team1:
          return {
            key: mt,
            name: golfTeam1?.name,
            active: currentTeamMode === mt,
          }
        case golferTeamModes.team2:
          return {
            key: mt,
            name: golfTeam2?.name,
            active: currentTeamMode === mt,
          }
        default:
          return {
            key: mt,
            active: currentTeamMode === mt,
          }
      }
    })

    return {
      _golferTeamModes: mts,
    }
  }, [])

  const handleCancelHandicap = () => setCurrentGolferHcp()
  const handleCancelEdit = () => setCurrentGolferEdit()
  const handleCancelChange = () => setCurrentChangeGolfer()

  useEffect(() => {
    if (isTournament) {
      const gc = tournamentGolfCourses && Object.values(tournamentGolfCourses)[0]
      if (gc) {
        update_golfHandicapRecommendations({ golfers: golfers_tournament, golfCourse: gc })
      }
      const glfs = golfers_tournament || golfers
      const { golferRecords } = get_golferRecords({
        matches: matches_rounds,
        golfers: glfs,
        teams
      })
      _.forEach(golferRecords, (gr, grk) => {
        if (glfs?.[grk]) {
          glfs[grk]._record = gr
        }
      })
      setCurrentGolfers(_.cloneDeep(glfs))
    } else[
      setCurrentGolfers(golfers_event)
    ]
  }, [golfers_event, golfers_tournament, matches_rounds]);


  const golferItem_record = (golferRecord, itemKey) => {
    const { wins, losses, ties, points, holes } = golferRecord
    const { wins: wins_hole, losses: losses_hole } = holes
    const pointsDiff = wins - losses
    const holeDiff = wins_hole - losses_hole
    return <div className='lbl-short'>
      <Label title={'Points'} size='mini' className='glf-p' color={'blue'}> {points}</Label>
      <Label title={'Points Diff'} size='mini' className='glf-p' color={pointsDiff > 0 ? 'green' : pointsDiff < 0 ? 'red' : 'black'}> {pointsDiff}</Label>
      <Label title={'Holes Diff'} size='mini' className='glf-hd' color={holeDiff > 0 ? 'green' : holeDiff < 0 ? 'red' : 'black'}>{holeDiff}</Label>
    </div >
  }

  const golferItem_records = (golferRecord, itemKey) => {
    const { wins, losses, ties, points, holes } = golferRecord
    const { wins: wins_hole, losses: losses_hole, ties: ties_hole } = holes
    const holeDiff = wins_hole - losses_hole
    return <div className={'sqr-box-sub'}>
      <Label.Group size='mini' key={uniqueKey('glfr', itemKey)} className={'golfer-record'} >
        <Label className='glf-p' color='blue'>{'Points: '}{points}</Label>
        <Label className='glf-w' color='green'>{'Wins: '}{wins}</Label>
        <Label className='glf-t' color='grey'>{'Ties: '}{ties}</Label>
        <Label className='glf-l' color='red'>{'Losses: '}{losses}</Label>

        <Label className='glf-hd' color='blue'>{`Hole Diff: ${holeDiff}`}</Label>
        <Label className='glf-hw' color='green'>{'HW: '}{wins_hole}</Label>
        <Label className='glf-ht' color='grey'>{'HT: '}{ties_hole}</Label>
        <Label className='glf-hl' color='red'>{'HL: '}{losses_hole}</Label>
      </Label.Group >
    </div>
  }

  const golferItem_opponents = (golferRecord, itemKey) => {
    const { opponents, partners } = golferRecord
    const divs = []

    const _opponents = _.orderBy(opponents, ['lastName', 'firstName'])

    if (_opponents) {
      _.forEach(_opponents, (opponent) => {
        const { firstName, lastName, tournamentHandicapIndex, matchStatuses } = opponent
        _.forEach(matchStatuses, (matchStatus) => {
          const { finalScore, round, won, tied } = matchStatus
          const partner = _.find(partners, partner => partner?.rounds?.[round])
          const roundStyle = { backgroundColor: roundColors[round], color: 'black' }
          let resultColor = won ? 'green' : 'red'
          if (tied) { resultColor = 'grey' }
          divs.push(
            <div className='golfer-opp'>
              <div>{`${firstName} ${lastName} (${tournamentHandicapIndex})`}</div>
              <Label style={roundStyle}>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <div>{_.startCase(round)}</div>
                  {partner && <div style={{ fontWeight: 'normal', fontSize: '.7rem' }}>{`w/ ${partner?.firstName} ${partner?.lastName}`}</div>}
                </div>
              </Label>
              <Label color={resultColor}>{finalScore}</Label>
            </div>
          )
        })
      })
    }
    return <div className={'sqr-box-sub'}>
      <div className='golfer-opps'>
        {divs}
      </div>
    </div>
  }

  const golferItems_courseHandicaps = (glf) => {
    const { _courseHandicaps } = glf ?? {}
    const _chs = _.orderBy(_courseHandicaps, ['courseHandicap'], ['desc'])
    const chps = _.map(_chs, ch => {
      const style = getSplitColorStyles({ backgroundColor: ch.teeBoxKey })
      let bgc;
      let borderColor;
      const rtb = ch.teeBoxKey
      const recommendedTeeBox_split = rtb ? rtb.split('/') : []
      if (recommendedTeeBox_split.length > 1) {
        bgc = recommendedTeeBox_split[0].toLowerCase()
        borderColor = recommendedTeeBox_split[1].toLowerCase()
      } else {
        bgc = rtb ? rtb.toLowerCase() : null
        borderColor = rtb ? rtb.toLowerCase() : null
      }
      return <Label
        title={rtb}
        style={{
          ...style,
          marginBottom: '.5em',
        }} size='tiny'
      >{`${ch.courseHandicap}`}</Label>
    })
    return <div
      className={'sqr-box-sub'}
      style={{ display: 'flex', flexDirection: 'row', backgroundColor: 'var(--off-black-5)' }}
    >
      {chps}
    </div>
  }

  const golfers_bySort = (glfs) => {
    switch (currentSortMode) {
      case golferRecordSorts.name:
        return _.sortBy(glfs, 'lastName')

      case golferRecordSorts.points:
        return _.orderBy(glfs, ['_record.points', '_record.holeDiff', 'lastName'], ['desc', 'desc'])

      case golferRecordSorts.holes:
        return _.orderBy(glfs, ['_record.holeDiff', 'lastName'], ['desc', 'desc'])

      default:
        return _.sortBy(glfs, 'lastName')
    }
  }

  const ims_golfers = () => {

    const fnPre = (item) => {

      const ocp = () => {
        setCurrentChangeGolfer(item)
        // setCurrentGolferEdit && setCurrentGolferEdit({ golfer: item, handicapRowMode: handicapRowModes.handicapIndex })
      }

      let sty = {};
      let tc = ''
      let icon;

      const iconProps = {
        color: 'grey',
      }

      const { teamNumber, _authData, lastName, firstName } = item

      const g = _.find(golfers_event, { lastName, firstName })
      const { phoneNumber, email } = g

      if (phoneNumber && email) {
        icon = 'address book outline'
      } else if (phoneNumber) {
        icon = 'phone'
      } else if (email) {
        icon = 'mail'
      }

      switch (teamNumber) {
        case 1:
          sty = golfTeam1Style;
          tc = createInitials(teams?.team1?.name)
          break;
        case 2:
          sty = golfTeam2Style;
          tc = createInitials(teams?.team2?.name)
          break;
      }
      if (allowMods) {
        if (_authData) {
          const { isRecent, lastRefreshTime } = _authData ?? {}
          iconProps.title = lastRefreshTime
          iconProps.color = 'blue';
          if (isRecent) {
            iconProps.color = 'green'
          }
        }
        return <Label size='mini' style={{ marginRight: '1em', ...sty }} onClick={(e) => { ocp() }}>
          <Icon {...iconProps} name={icon || 'user'} /> {tc}
        </Label>
      } else {
        return <Label size='mini' circular style={{ marginRight: '1em', ...sty }}>{tc}</Label>
      }

    }

    const fnAlt = (item) => {
      const oc = (e, hrm) => {
        e.stopPropagation()
        switch (hrm) {
          case handicapRowModes.courseHandicap:
          case handicapRowModes.tournamentHandicapIndex:
          case handicapRowModes.handicapIndex:
            setCurrentGolferHcp && setCurrentGolferHcp({ golfer: item, handicapRowMode: hrm })
        }
      }

      switch (currentHeaderMode) {
        case golferTournamentHeaderModes.records:
          return golferItem_record(item?._record, item?._itemKey)

        default:
          const _handicaps = get_golferHandicaps({ golfer: item })

          return <GolferHandicapLabelGroup
            _handicaps={_handicaps}
            handicapMode={isTournament ? handicapModes.tournament : handicapModes.event}
            handleShowHandicap={oc}
          />
      }
    }

    // these will apper if the currentHeaderMode is selected
    const fnSub = (item) => {
      switch (currentHeaderMode) {
        case golferTournamentHeaderModes.records:
          return item?._record ? golferItem_records(item?._record, item?._itemKey) : <div className={'sqr-box-sub'}>{`No ${_.startCase(currentHeaderMode)}`}</div>
        case golferTournamentHeaderModes.opponents:
          return item?._record ? golferItem_opponents(item?._record, item?._itemKey) : <div className={'sqr-box-sub'}>{`No ${_.startCase(currentHeaderMode)}`}</div>
        case golferTournamentHeaderModes.courseHandicaps:
          return golferItems_courseHandicaps(item)
      }
    }

    let _golfers = currentGolfers

    switch (currentTeamMode) {
      case golferTeamModes.all:
        break;
      case golferTeamModes.team1:
        _golfers = _.filter(currentGolfers, { teamNumber: 1 })
        break
      case golferTeamModes.team2:
        _golfers = _.filter(currentGolfers, { teamNumber: 2 })
        break;
    }

    const players = golfers_bySort(_golfers)

    return <ItemMenuSquares
      menuItems={players}
      imsType={_imsTypes.inline}
      fn_preContent={fnPre}
      fn_altContent={fnAlt}
      fn_subContentt={fnSub}
      noItemIcon={true}
      style={{ padding: '.5em' }}
    />
  }

  if (currentGolferHcp) {
    return <GolferHandicap
      currentGolferHcp={currentGolferHcp}
      golfer={currentGolferHcp.golfer}
      handicapRowMode={currentGolferHcp.handicapRowMode}
      handicapMode={handicapModes.tournament}
      showTeebox={true}
      handleCancel={handleCancelHandicap} />
  } else if (currentGolferEdit) {
    return <GolferHandicap
      currentGolferHcp={currentGolferEdit}
      golfer={currentGolferEdit.golfer}
      handicapRowMode={handicapRowModes.handicapIndex}
      handicapMode={handicapModes.tournament}
      showTeebox={true}
      handleCancel={handleCancelEdit} />
  } else if (currentChangeGolfer) {
    return <GolferChange
      golfer={currentChangeGolfer}
      handleCancel={handleCancelChange} />
  } else if (currentHeaderMode === golferTournamentHeaderModes_admin.add) {
    const hc = () => { setCurrentHeaderMode(golferTournamentHeaderModes.handicaps) }
    return <GolferAdd
      handleCancel={hc}
      currentGolfers={golfers}
      teams={teams}
    />
  }

  const header_menu_teams = () => {
    const oc = (item) => { setCurrentTeamMode(item?.key) }
    return <ItemMenuSquares
      menuItems={_golferTeamModes}
      activeItem={currentTeamMode}
      imsType={_imsTypes.menu}
      onClick={oc}
    />
  }

  const header_menu_top = () => {
    const oc = (item) => { setCurrentHeaderMode(item) }
    let menuItems = isSuperAdminDeveloper ? golferEventHeaderModes_admin : golferEventHeaderModes
    if (isTournament) {
      menuItems = isSuperAdminDeveloper ? golferTournamentHeaderModes_admin : golferTournamentHeaderModes
    }
    return <ItemMenuSquares
      menuItems={menuItems}
      activeItem={currentHeaderMode}
      imsType={_imsTypes.menu}
      onClick={oc}
    />
  }

  const header_menu_sort = () => {
    switch (currentHeaderMode) {
      case golferTournamentHeaderModes.records:
        const oc = (item) => { setSortMode(item) }
        return <ItemMenuSquares
          menuItems={golferRecordSorts}
          activeItem={currentSortMode}
          imsType={_imsTypes.menu}
          onClick={oc}
        />
    }
  }

  const content = () => <Wrapper
    search={<div>
      {isTournament && header_menu_teams()}
      {header_menu_top()}
      {header_menu_sort()}
    </div>}
    content={ims_golfers()}
  ></Wrapper>

  return content()

}
